import { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { useScrollRestore } from './useScrollRestore';
const ScrollRestorationHandler = function ScrollRestorationHandler({ location, ignoreForRouteTypes }) {
    const prevLocation = useRef();
    useEffect(() => {
        prevLocation.current = location;
    }, [location]);
    useScrollRestore({
        location,
        prevLocation: prevLocation.current,
        ignoreForRouteTypes
    });
    return null;
};
export default withRouter(ScrollRestorationHandler);
//# sourceMappingURL=ScrollRestorationHandler.js.map